import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import DivisionPage from "@/pages/DivisionPage";
import AdminInquiries from "@/pages/AdminInquiries";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App grain" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aurix-studio" element={<DivisionPage />} />
          <Route path="/aurix-media" element={<DivisionPage />} />
          <Route path="/aurix-growth" element={<DivisionPage />} />
          <Route path="/aurix-fmcg-labs" element={<DivisionPage />} />
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
          <Route path="/divisions/:slug" element={<DivisionPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "rgba(10,10,12,0.92)",
            color: "#f5f5f5",
            border: "1px solid rgba(212,175,55,0.25)",
            backdropFilter: "blur(20px)",
          },
        }}
      />
    </div>
  );
}

export default App;
